import React, { useEffect, useMemo } from "react";
import { Box, Button, Chip, Divider, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { GradientButtonOutline } from "components/GradientButton";
import useApi from "_api/index";
import TableData from "components/Car/Table";
import { render } from "@testing-library/react";
import Actions from "components/Car/Actions";
import { Description, Edit, Print } from "@mui/icons-material";
import FormDocumentList from "components/Car/FormDocumentList";
import ModalCreateTransferAndReceiptBuy from "components/Modal/Car/FormDocuments/TransferAndReceiptBuy";
import ModalPowerOfAttorney from "components/Modal/Car/FormDocuments/PowerOfAttorney";
import { BackButton } from "components/Button";
import ModalContractBuyAndSell from "components/Modal/Car/FormDocuments/ContractBuyAndSell";

const FormBuyCars = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [car, setCar] = React.useState(null);
  const [isTransferModalOpen, setIsTransferModalOpen] = React.useState(false);
  const [isPowerOfAttorneyModalOpen, setIsPowerOfAttorneyModalOpen] =
    React.useState(false);
  const [isContractBuySellModalOpen, setIsContractBuySellModalOpen] =
    React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await useApi.buy_car.getCarBuyById(id);
      if (response.success) {
        setCar(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) {
      console.error("ID is not provided");
      return;
    }
    fetchData();
  }, [id]);

  const handlePrintPDF = async (document) => {
    let response = null;
    try {
      if (document.document_type === "car_transform") {
        response = await useApi.buy_car.printPdfCarTransferBuy(
          document.document_id
        );
      } else if (document.document_type === "car_power_of_attorney") {
        response = await useApi.buy_car.printPdfPowerOfAttorneyBuy(
          document.document_id
        );
      } else if (document.document_type === "car_sell_contact") {
        response = await useApi.buy_car.printPdfContractBuySell(
          document.document_id
        );
      }
      if (response && response.status === 200) {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(url, "_blank");
      } else {
        throw new Error("Failed to generate PDF document");
      }
    } catch (error) {
      console.error("Error printing PDF document:", error);
    }
  };

  return (
    <>
      <FormDocumentList
        car={car ? car.car : null}
        type="buy_car"
        columns={[
          { key: "document", label: "ฟอร์มเอกสาร" },
          {
            key: "action",
            label: "",
            style: {
              textAlign: "right",
            },
            render: (row) => {
              const findCreated = car
                ? car.documents?.some(
                    (doc) => doc.document_type === row.document_type
                  )
                : false;

              return car?.car?.car_status_id === 5 && !findCreated ? (
                <Chip label="ไม่พบเอกสารฉบับนี้" color="default" />
              ) : (
                <Actions
                  menuList={[
                    car?.car?.car_status_id !== 5 && {
                      label: findCreated ? "แก้ไขเอกสาร" : "สร้างเอกสาร",
                      icon: findCreated ? <Edit /> : <Description />,
                      onClick: () => {
                        // handleUpdateStsatus(row.document);
                        console.log("row", row);
                        if (row.id === 1) {
                          setIsTransferModalOpen(true);
                        } else if (row.id === 2) {
                          setIsPowerOfAttorneyModalOpen(true);
                        } else if (row.id === 3) {
                          setIsContractBuySellModalOpen(true);
                        }
                        setSelectedRow(
                          car.documents?.find(
                            (doc) => doc.document_type === row.document_type
                          ) || null
                        );
                      },
                    },
                    findCreated && {
                      label: "พิมพ์เอกสาร",
                      icon: <Print />,
                      onClick: () => {
                        handlePrintPDF(
                          car.documents?.find(
                            (doc) => doc.document_type === row.document_type
                          )
                        );
                      },
                    },
                  ]}
                />
              );
            },
          },
        ]}
        data={[
          {
            id: 1,
            document: "แบบคำขอโอนและรับโอน",
            document_type: "car_transform",
          },
          {
            id: 2,
            document: "หนังสือมอบอำนาจ",
            document_type: "car_power_of_attorney",
          },
          {
            id: 3,
            document: "หนังสือสัญญาซื้อ - ขายรถ",
            document_type: "car_sell_contact",
          },
        ]}
        loading={loading}
      />

      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-start" }}>
        <BackButton onClick={() => navigate("/car/buy_cars")} />
      </Box>
      <ModalCreateTransferAndReceiptBuy
        isOpen={isTransferModalOpen}
        onClose={() => setIsTransferModalOpen(false)}
        car={car ? car.car : null}
        customer={car ? car.customer : null}
        order={car ? car.order : null}
        document={selectedRow}
        onSuccess={() => {
          setIsTransferModalOpen(false);
          fetchData();
        }}
      />

      <ModalPowerOfAttorney
        isOpen={isPowerOfAttorneyModalOpen}
        onClose={() => setIsPowerOfAttorneyModalOpen(false)}
        car={car ? car.car : null}
        customer={car ? car.customer : null}
        order={car ? car.order : null}
        document={selectedRow}
        onSuccess={() => {
          setIsPowerOfAttorneyModalOpen(false);
          fetchData();
        }}
      />
      <ModalContractBuyAndSell
        isOpen={isContractBuySellModalOpen}
        onClose={() => setIsContractBuySellModalOpen(false)}
        car={car ? car.car : null}
        customer={car ? car.customer : null}
        order={car ? car.order : null}
        document={selectedRow}
        onSuccess={() => {
          setIsContractBuySellModalOpen(false);
          fetchData();
        }}
        type="buy_car"
      />
    </>
  );
};

export default FormBuyCars;
